<header>
  <mat-toolbar class="white-bg" *ngIf="campaign && campaign.private">
    <mat-toolbar-row>
      <img src="assets/images/logo.png" class="logo" alt="BeeFund" width="250" height="53" fetchpriority="high">
      <span class="spacer"></span>
      <nav class="locale-switcher" aria-label="Taalselectie" *ngIf="campaign.countryId == 2">
        <button
          *ngFor="let language of languages"
          type="button"
          class="lang-toggle-btn"
          [class.active]="selectedLanguage === language.value"
          [attr.aria-pressed]="selectedLanguage === language.value"
          [attr.lang]="language.value"
          [attr.aria-label]="language.label"
          (click)="onLanguageChange(language.value)">
          {{ language.name }}
        </button>
      </nav>
    </mat-toolbar-row>
  </mat-toolbar>
  <mat-toolbar class="white-bg" *ngIf="!campaign || !campaign.private">
    <mat-toolbar-row>
      <a [routerLink]="''" aria-label="BeeFund Home"><img src="assets/images/logo.png" class="logo" alt="BeeFund" width="250" height="53" fetchpriority="high"></a>
      <span class="spacer"></span>
      <div class="block sm:hidden">
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menu">
          <mat-icon aria-hidden="true">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item *ngIf="username" routerLink='/edit-profile'>
            <span class="margin-right-10">{{"Welkom"|translate}} {{username}}</span>
          </button>
          <button mat-menu-item *ngIf="username" (click)="logout()">
            <span>{{ 'Uitloggen' | translate }}</span>
          </button>
          <button mat-menu-item *ngIf="!username" (click)="openLoginDialog()">
            <span class="margin-right-10">{{ 'Inloggen' | translate }}</span>
          </button>
          <button mat-menu-item *ngIf="!username" (click)="openSignUpDialog()">
            <span>{{ 'Registreren' | translate }}</span>
          </button>
        </mat-menu>
      </div>
      <nav class="hidden sm:block" aria-label="Hoofdnavigatie">
        <a *ngIf="username" class="welcome margin-right-10" routerLink='/edit-profile'>{{'Welkom'|translate}} {{username}}</a>
        <a *ngIf="username" role="button" tabindex="0" (click)="logout()" (keydown.enter)="logout()">{{ 'Uitloggen' | translate }}</a>
        <a (click)="openLoginDialog()" (keydown.enter)="openLoginDialog()" role="button" tabindex="0" *ngIf="!username" class="margin-right-10">{{ 'Inloggen' | translate }}</a>
        <button *ngIf="!username" type="button" mat-raised-button class="button" color="warn" (click)="openSignUpDialog()">{{'Registreren'|translate}}</button>
      </nav>
      <div class="locale-switcher" role="group" aria-label="Land- en taalselectie">
        <div class="locale-picker country-picker">
          <label for="header-country-select" class="visually-hidden">Selecteer land</label>
          <span [class]="selectedCountryObject()?.class + ' fallback-flag'" aria-hidden="true"></span>
          <select
            id="header-country-select"
            name="country"
            class="locale-select country-select"
            aria-label="Selecteer land"
            [(ngModel)]="selectedCountry"
            (ngModelChange)="onCountryChange($event)">
            <button type="button">
              <selectedcontent></selectedcontent>
            </button>
            <option
              *ngFor="let country of countries"
              [value]="country.value"
              [attr.aria-label]="country.name | translate">
              <span [class]="country.class" aria-hidden="true"></span>
              <span class="option-label">{{ country.name | translate }}</span>
            </option>
          </select>
        </div>

        <div class="locale-picker language-picker" *ngIf="languages.length > 1">
          <label for="header-language-select" class="visually-hidden">Selecteer taal</label>
          <select
            id="header-language-select"
            name="language"
            class="locale-select language-select"
            aria-label="Selecteer taal"
            [(ngModel)]="selectedLanguage"
            (ngModelChange)="onLanguageChange($event)">
            <button type="button">
              <selectedcontent></selectedcontent>
            </button>
            <option
              *ngFor="let language of languages"
              [value]="language.value"
              [attr.lang]="language.value"
              [attr.aria-label]="language.label">
              <span class="option-code">{{ language.name }}</span>
              <span class="option-label">{{ language.label }}</span>
            </option>
          </select>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</header>
